// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import 'babel-polyfill';
import VueJsonp from 'vue-jsonp'
import App from './App';
import router from './router';
import ElementUI from 'element-ui';
import axios from 'axios';
import 'element-ui/lib/theme-chalk/index.css';
import store from './store';
import storage from './store/storage.js';
import resetStorage from './store/resetStorage.js';
import VueLazyLoad from 'vue-lazyload';
import {Message} from 'element-ui';
import share from './store/share.js';


Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VueJsonp); 
Vue.prototype.$http = axios;
Vue.prototype.storage = storage;
Vue.prototype.resetStorage = resetStorage;
Vue.prototype.share = share;
Vue.use(VueLazyLoad,{
  preLoad: 1.3,
  error: '../static/default_estate.jpg',
  loading: '../static/load.gif',
  attempt: 1
}); 



// http request 拦截器
axios.interceptors.request.use(
  config => {
      var cityCode =  localStorage.getItem('cityCode');
      if(cityCode==''){
        cityCode = 'sz';
      }
    config.headers['city'] = cityCode;　
    return config;
  },
  error => {
    return Promise.reject(error.response);
  }
);

// http response 拦截器
axios.interceptors.response.use(
  response => {
    if(response.data.code!=200){
      Message.error("请求界面信息出错,请稍后再试！");
    }
    return response;
  },
  error => {
    return Promise.reject(error.response);
  }
);

// 跳转页面回到页首
router.afterEach((to,from,next)=>{
  window.scrollTo(0,0)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js